<template>
  <article class="layout-section -bg-shade">
    <div class="layout-section__hgroup">
      <h2 class="layout-section__title">Trois outils complémentaires vous sont offerts</h2>
      <p>Ces outils sont disponibles en format PDF (100 $ pour les trois outils).</p>
    </div>

    <section class="layout-section__index">
      <div class="card -bigger">
        <h4 class="card__uptitle">Coût : 60 $</h4>
        <h3 class="card-figure__title">Concevoir, animer, accompagner et évaluer</h3>
        <h4 class="card-figure__subtitle">Recueil de fiches thématiques centrées sur l’ingénierie de formation</h4>

        <p>
          Plus de 40 fiches thématiques définissant les fondements de l’ingénierie de la formation. De la conception
          d’une activité à l’évaluation des apprentissages, en passant par l’accompagnement des personnes apprenantes et
          l’évaluation de leurs acquis, ces fiches vous feront découvrir les bases de l’ingénierie de la formation. Vous
          pourrez développer des activités de formation adaptées aux besoins des apprenants adultes. Surtout, vous
          pourrez identifier des solutions de formation adaptés à vos besoins.
        </p>

        <RouterLink :to="{ name: 'resources-ncf' }" class="link card__cta">
          En savoir plus
          <SvgIcon id="action-arrow" />
        </RouterLink>
      </div>
    </section>
  </article>
</template>

<script>
export default {
  name: 'ResourcesTrainingIndex'
}
</script>
